module.exports = __webpack_public_path__ + "img/reset_sensor_step_1.5e481812.png";